import {
    createTodos as createTodosPromise,
    createSubtodos as createSubtodosPromise,
    CreateTodosResponse,
    CreateSubtodoResponse,
} from 'owa-todo-cache';
import { Subtodo, Todo } from 'owa-todo-types';
import { TodoActionTelemetryData } from '../schema/telemetry/TodoActionTelemetryData';
import { logUsage } from 'owa-analytics';
import { createDatapointConfig } from '../actions/createDatapointConfig';

export function createTodos(
    todos: Partial<Todo>[],
    folderId: string,
    telemetryData: TodoActionTelemetryData
): Promise<CreateTodosResponse> {
    const dpConfig = createDatapointConfig('create', telemetryData);
    logUsage(dpConfig.name, dpConfig.customData, dpConfig.options);
    return createTodosPromise(todos, folderId, {
        actionSource: telemetryData.actionSource,
    });
}

export function createSubtodos(
    todos: Partial<Subtodo>[],
    parentTodoId: string,
    telemetryData: TodoActionTelemetryData
): Promise<CreateSubtodoResponse> {
    const dpConfig = createDatapointConfig('addSubTodo', telemetryData);
    logUsage(dpConfig.name, dpConfig.customData, dpConfig.options);
    return createSubtodosPromise(todos, parentTodoId, {
        actionSource: telemetryData.actionSource,
    });
}
